export default "31,Barskog\n32,Lauvskog\n33,Blandingsskog\n35,Lauvblandingsskog\n39,Ikke tresatt\n98,Ikke relevant\n99,Ikke registrert\n"